export default __webpack_public_path__ + "static/local-dark-eb4f2a97b9352a630cc4777aed576f63.png";